import styled from "styled-components";

export const TooltipCaption = styled.caption`
  font-weight: bold;
  text-align: left;
  color: ${({ theme }) => theme.color.fg.onemphasis.subtle};
`;
